import { NamedError } from "../../utils/Errors";

export class DocumentStorageError extends NamedError<DocumentStorageErrors> {}

export enum DocumentStorageErrors {
    CorruptTranscriptSource = "CorruptTranscriptSource"
}